import type { CollapseGhostContainerProps } from "./collapse-ghost-container.type";

import { Collapse } from "antd";

import "./collapse-ghost-container.style.less";

export const CollapseGhostContainer = ({
  open,
  children,
}: CollapseGhostContainerProps) => {
  const itemKey = "collapse-ghost-container-item";

  return (
    <Collapse
      ghost
      activeKey={open ? [itemKey] : []}
      items={[{ key: itemKey, children }]}
      classNames={{
        root: "collapse-ghost-container",
        header: "collapse-ghost-container--header",
        body: "collapse-ghost-container--body",
      }}
    />
  );
};
